// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__FGwWc","bounce":"Modal_bounce__ik-eQ","overlay":"Modal_overlay__V8epE","Wrapper":"Modal_Wrapper__eEpET"};